<template>
  <el-dialog
    title="新建线索"
    :visible.sync="dialogVisible"
    width="60%"
    class="addClueDialog"
    :close-on-click-modal="false"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" label-position="left" ref="addClueForm" :rules="rules" label-width="120px" :model="formData">
      <el-row>
        <el-col :span="12">
          <el-form-item label="客户单位" prop="unit">
            <el-select
              v-model="formData.unit"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="unitRemoteSearch"
              :loading="unitLoading"
              @blur="unitBlurHandle"
            >
              <el-option v-for="(item, index) in unitList" :key="index" :label="item" :value="item" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="线索名称" prop="leadName">
            <el-input v-model="formData.leadName" placeholder="请输入内容" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="客户名称" prop="name">
            <el-input v-model="formData.name" placeholder="请输入内容" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="客户身份" prop="identity">
            <el-select v-model="formData.identity" clearable placeholder="请选择">
              <el-option v-for="item in identityList" :key="item.id" :label="item.fieldValue" :value="item.fieldValue" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="formData.phone" placeholder="请输入内容" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="职务">
            <el-input v-model="formData.position" placeholder="请输入内容" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="邮箱">
            <el-input v-model="formData.email" placeholder="请输入内容" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="城市" prop="city">
            <el-select
              v-model="formData.city"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              :loading="cityLoading"
              @change="cityChange"
            >
              <el-option v-for="(item, index) in cityList" :key="index" :label="item" :value="item" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="区域" prop="region">
            <el-input v-model="formData.region" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="行业" prop="industry">
            <el-select v-model="formData.industry" placeholder="请选择" @change="industryChange">
              <el-option v-for="(item, index) in industryList" :key="index" :label="item" :value="item" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="大区" prop="bigArea">
            <el-input v-model="formData.bigArea" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="线索来源" prop="leadSourceCode">
            <el-select v-model="formData.leadSourceCode" clearable placeholder="请选择" @change="leadSourceChnage">
              <el-option v-for="item in leadSourcList" :key="item.fieldKey" :label="item.fieldValue" :value="item.fieldKey" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品线" prop="productLine">
            <el-select v-model="formData.productLine" clearable multiple collapse-tags placeholder="请选择">
              <el-option v-for="item in productLineList" :key="item.fieldKey" :label="item.fieldValue" :value="item.fieldValue" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="线索分类">
            <el-select v-model="formData.leadTypeCode" disabled placeholder=" ">
              <el-option v-for="item in leadTypeList" :key="item.fieldKey" :label="item.fieldValue" :value="item.fieldKey" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="线索录入人">
            <el-input v-model="this.$store.state.userInfo.sysUser.userName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="业务单元">
            <el-input v-model="formData.businessUnit" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="formData.remark" maxlength="1000" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submitHandlen">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { roleManagementApi } from '@/views/backStageManagement/service';
import { waitingProcessingApi } from '../../service';
import { arrayQuery } from '@/utils/utils';
export default {
  data () {
    let unitValidator = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入客户单位'));
      } else {
        waitingProcessingApi.unitValidator(value).then(res => {
          if (res.status === '200' && res.data) {
            callback();
          } else {
            callback(new Error('单位名称有误'));
          }
        }).catch(() => {
        });
      }
    };
    let phoneNumberValidator = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入联系方式'));
      } else if (!/^[0-9]{7,}$/.test(value)) {
        callback(new Error('手机号格式有误'));
      } else {
        callback();
      }
    };
    return {
      rules: {
        unit: [
          { required: true, validator: unitValidator, trigger: 'change' }
        ],
        leadName: [
          { required: true, message: '请输入线索名称', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入客户名称', trigger: 'blur' }
        ],
        identity: [
          { required: true, message: '请选择客户身份', trigger: 'change' }
        ],
        phone: [
          { required: true, validator: phoneNumberValidator, trigger: 'blur' }
        ],
        city: [
          { required: true, message: '请选择城市', trigger: 'change' }
        ],
        region: [
          { required: true, message: '请选择区域', trigger: 'change' }
        ],
        industry: [
          { required: true, message: '请选择行业', trigger: 'change' }
        ],
        bigArea: [
          { required: true, message: '请选择大区', trigger: 'change' }
        ],
        productLine: [
          { required: true, message: '请选择产品线', trigger: 'change' }
        ],
        remark: [
          { required: true, message: '请输入备注信息', trigger: 'blur' }
        ],
        leadSourceCode: [
          { required: true, message: '请选择线索来源', trigger: 'change' }
        ]
      },
      dialogVisible: false,
      formData: {},
      leadTypeList: [],
      identityList: [],
      leadSourcList: [],
      accountTypeList: [],
      productLineList: [],
      industryList: [],
      cityLoading: false,
      cityList: [],
      unitLoading: false,
      unitList: [],
      subFlag: true
    };
  },
  props: {
    addClueShow: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    addClueShow (val) {
      if (val) {
        this.getOptionList('客户身份').then(res => {
          this.identityList = res.data;
        });
        this.getOptionList('线索分类').then(res => {
          this.leadTypeList = res.data;
        });
        this.getOptionList('线索来源').then(res => {
          this.leadSourcList = res.data;
        });
        this.getOptionList('manage_product_line').then(res => {
          this.productLineList = res.data;
        });
        this.getIndustryList();
      } else {
        this.formData = {};
      }
      this.$nextTick(() => {
        this.$refs.addClueForm.clearValidate();
      });
      this.dialogVisible = val;
    }
  },
  methods: {
    leadSourceChnage (val) {
      if (!val) {
        this.$set(this.formData, 'leadTypeCode', '');
        return;
      }
      // 如果线索来源是总部活动|模板活动|区域活动，线索分类则显示市场活动，否就显示线上营销
      if (val === '5' || val === '6' || val === '7') {
        this.$set(this.formData, 'leadTypeCode', '2');
      } else {
        this.$set(this.formData, 'leadTypeCode', '1');
      }
    },
    unitBlurHandle (e) {
      if (e.target.value) {
        this.$set(this.formData, 'unit', e.target.value);
      }
    },
    unitRemoteSearch (query) {
      if (query !== '') {
        this.unitLoading = true;
        waitingProcessingApi.getUnitList(query).then(res => {
          if (res.status === '200') {
            if (res.data && res.data.length > 0) {
              this.unitList = res.data;
            } else {
              this.unitList = [];
            }
          }
          this.unitLoading = false;
        });
      } else {
        this.unitList = [];
      }
    },
    getIndustryList () {
      waitingProcessingApi.getIndustryList().then(res => {
        if (res.status === '200') {
          this.industryList = res.data;
        }
      });
    },
    getBusinessUnitList (city, industry) {
      waitingProcessingApi.getBusinessUnitList(city, industry).then(res => {
        if (res.status === '200') {
          this.$set(this.formData, 'businessUnit', res.data[0]);
        }
      });
    },
    industryChange (val) {
      this.$set(this.formData, 'businessUnit', '');
      this.getBusinessUnitList(this.formData.city, val);
    },
    cityChange (val) {
      if (val) {
        // 清空业务单元
        this.$set(this.formData, 'businessUnit', '');
        waitingProcessingApi.getRegionArea(val).then(res => {
          if (res.status === '200') {
            this.$set(this.formData, 'bigArea', res.data.bigArea);
            this.$set(this.formData, 'region', res.data.region);
          }
        });
      }
    },
    remoteMethod (query) {
      if (query !== '') {
        this.cityLoading = true;
        waitingProcessingApi.getCityList(query).then(res => {
          if (res.status === '200') {
            if (res.data && res.data.length > 0) {
              this.cityList = res.data;
            } else {
              this.cityList = [];
            }
          }
          this.cityLoading = false;
        });
      } else {
        this.cityList = [];
      }
    },
    submitHandlen () {
      this.$refs['addClueForm'].validate((valid) => {
        if (
          !this.formData.unit ||
          !this.formData.leadName ||
          !this.formData.name ||
          !this.formData.identity ||
          !this.formData.phone ||
          !/^[0-9]{7,}$/.test(this.formData.phone) ||
          !this.formData.city ||
          !this.formData.region ||
          !this.formData.industry ||
          !this.formData.bigArea ||
          !this.formData.productLine ||
          !this.formData.remark
        ) {
          return;
        }
        let params = JSON.parse(JSON.stringify(this.formData));
        if (params.leadTypeCode) {
          params.leadTypeName = arrayQuery(params.leadTypeCode, this.leadTypeList, 'fieldKey').fieldValue;
        }
        if (params.leadSourceCode) {
          params.leadSourceName = arrayQuery(params.leadSourceCode, this.leadSourcList, 'fieldKey').fieldValue;
        }
        params.productLine = params.productLine.join(',');
        this.$emit('addSubmitHandle', params);
      });
    },
    getOptionList (params) {
      return new Promise((resolve, reject) => {
        roleManagementApi.getConfigureList(params).then(res => {
          if (res.status === '200') {
            resolve(res);
          }
        });
      });
    },
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    }
  }
};
</script>

<style scoped>

</style>
